import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { StatusFilterData, StatusFilterModel, StatusFilterType } from './status-filter.model';
import moment from 'moment-timezone';
import { AbstractFilterTypeComponent } from '../../../../../Common/Filter/models/abstract-filter-type.component';
import { Subscription } from 'rxjs';
import { StatusFilterService } from './status-filter.service';
import { DiscoverRoutingService } from '../../../../DiscoverRouter/services/discover-routing.service';
import { DiscoverRouteTypeEnum } from '../../../../DiscoverRouter/enums/discover-route-type.enum';
import { EntityType } from '@api/targeting/enum/entity.type.enum';

@Component({
    selector: 'agpr-status-filter',
    templateUrl: './status-filter.component.html',
    styleUrls: ['./status-filter.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: StatusFilterComponent
        }
    ],
    standalone: false
})
export class StatusFilterComponent extends AbstractFilterTypeComponent implements OnInit, OnDestroy {
    readonly statusFilterType = StatusFilterType;
    readonly discoverRouteTypes = DiscoverRouteTypeEnum;
    readonly entityType = EntityType;

    @Input() declare filter: StatusFilterModel;

    value: StatusFilterData = new StatusFilterData();
    subscrpitions: Subscription[] = [];

    searchIncludesPrivateContacts: boolean = true;
    hasCreatedDate: boolean = false;
    hasUpdatedDate: boolean = false;
    /** Recently Verified filter hidden for now (10-1) */
    // hasVerifiedDate: boolean = false;
    hasNewEmploymentDate: boolean = false;
    hasActiveNotices: boolean = false;
    currentRouteType: DiscoverRouteTypeEnum;

    constructor(
        private statusFilterService: StatusFilterService,
        private discoverRoutingService: DiscoverRoutingService
    ) {
        super();
        this.subscrpitions.push(
            this.statusFilterService.getContactTypeFromSearch().subscribe(includePrivateContacts => {
                this.searchIncludesPrivateContacts = includePrivateContacts;
            }),
            this.discoverRoutingService.getCurrentRoute().subscribe(route => this.currentRouteType = route.type)
        );
    }

    ngOnInit(): void {
        this.refresh();
    }

    ngOnDestroy() {
        this.subscrpitions.forEach(x => x.unsubscribe());
    }

    refresh(): void {
        this.value = this.filter.getCurrentValue();
        this.hasCreatedDate = !!this.value.createdDate;
        this.hasUpdatedDate = !!this.value.updatedDate;
        // this.hasVerifiedDate = !!this.value.verifiedDate;
        this.hasNewEmploymentDate = !!this.value.newEmploymentDate;
        this.hasActiveNotices = !!this.value.hasActiveNotices;
    }

    handleChange(): void {
        this.filter.setCurrentValue(this.value);
    }

    dateFieldChecked(type: StatusFilterType) {
        switch (type) {
            case StatusFilterType.created:
                if (this.hasCreatedDate && !this.value.createdDate) {
                    this.value.createdDate = moment().subtract(30, 'days').startOf('day').toDate();
                }
                if (!this.hasCreatedDate) {
                    this.value.createdDate = undefined;
                }
                break;
            case StatusFilterType.updated:
                if (this.hasUpdatedDate && !this.value.updatedDate) {
                    this.value.updatedDate = moment().subtract(30, 'days').startOf('day').toDate();
                }
                if (!this.hasUpdatedDate) {
                    this.value.updatedDate = undefined;
                }
                break;
            // case StatusFilterType.verified:
            //     if (this.hasVerifiedDate && !this.value.verifiedDate) {
            //         this.value.verifiedDate = moment().subtract(90, 'days').toDate();
            //     }
            //     if (!this.hasVerifiedDate) {
            //         this.value.verifiedDate = undefined;
            //     }
            //     break;
            case StatusFilterType.newEmployment:
                if (this.hasNewEmploymentDate && !this.value.newEmploymentDate) {
                    this.value.newEmploymentDate = moment().subtract(30, 'days').startOf('day').toDate();
                }
                if (!this.hasNewEmploymentDate) {
                    this.value.newEmploymentDate = undefined;
                }
                break;
        }
        this.handleChange();
    }
}
